<mat-card class="header-wrapper" aria-label="user-details-card">
  <app-error [error]="error"> </app-error>

  @if (!error) {
    <mat-card-content>
    <div class="top-container">
      <div>
        <p class="mat-caption margin s2 bottom">
          {{ 'COMPANY_USERS.name' | translate }}
        </p>
        <p class="mat-body-1 name-container preserve-whitespace">
          <app-user-photo
            [image]="user && user.image"
            [user]="user"
            [bordercss]="bordercss"
            size="28px"
            aria-label="user-image"
          >
          </app-user-photo>
          {{ user && user.name }}
        </p>
      </div>

      <div>
        <p class="mat-caption margin s2 bottom">
          {{ 'RECENT_INVITES.email' | translate }}
        </p>
        <p class="mat-body-1">
          {{ user && user.email }}
          <br />
          @if (user && user.emailVerified) {
            <mat-chip
              class="margin s4 top"
              [disabled]="true"
            >
              {{ 'Email_Verified' | translate }}
            </mat-chip>
          }
          @if (user && !user.emailVerified) {
            <mat-chip
              class="pointer margin s4 top"
              (click)="showVerifyEmailInput()"
            >
              {{ 'Verify_Email' | translate }}
            </mat-chip>
          }
        </p>
      </div>
      @if (user && user.companyAccountId) {
        <div>
          <div>
            @if (user && user.companyName) {
              <p class="mat-caption margin s2 bottom">
                {{ 'COMPANY_PAGE.company' | translate }}
              </p>
            }
            @if (user && user.companyAccountId) {
              <p class="mat-body-1 pointer">
                <a (click)="goToCompany()">{{ user && user.companyName }}</a>
              </p>
            }
            @if (user && !user.companyAccountId) {
              <p class="mat-body-1">
                {{ user && user.companyName }}
              </p>
            }
          </div>
          @if (showAdminToggle) {
            <div>
              <p class="mat-caption margin s2 bottom">
                {{ 'COMPANY_PAGE.company_permissions' | translate }}
              </p>
              <mat-slide-toggle [(ngModel)]="isAdmin" (change)="toggleAdmin()" color="primary">
                {{ 'USER_DETAILS.make_admin' | translate }}
              </mat-slide-toggle>
            </div>
          }
        </div>
      }
    </div>
    </mat-card-content>
  }
  <mat-card-actions>
    @if (user && user.lastLoginString) {
      <span>Last active {{ user.lastLoginString | date: 'MM/d/yy' }} at
        {{ user.lastLoginString | date: 'shortTime' }}</span>
    }
  </mat-card-actions>
</mat-card>
